import React, { useEffect, useState } from "react";
import { DatePicker, Button, Tabs } from "antd";
import SingleOrderPendingCard from "../components/utility/SingleOrderPendingCard";
import SingleOrderActiveCard from "../components/utility/SingleOrderActiveCard";
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const Dashboard = () => {
  const disableFutureDates = (current) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current && current.toDate() > today;
  };

  const onChange = (key) => {
    console.log(key);
  };

  const tabStyle = {
    color: "rgba(0, 0, 0, 0.65)",
  };


 

  return (
    <>
      <div className="dashboard_home">
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #63adcf",
          }}
        >
          <div className="text_container">
            <h5>Pending Orders</h5>
            <h2>237</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #95e39c",
          }}
        >
          <div className="text_container">
            <h5>Active Orders</h5>
            <h2>164</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #70a78f",
          }}
        >
          <div className="text_container">
            <h5>Delivered Orders</h5>
            <h2>237</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #f38627",
          }}
        >
          <div className="text_container">
            <h5>Customer Cancelled Orders</h5>
            <h2>77</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #ffff33",
          }}
        >
          <div className="text_container">
            <h5>Restarants</h5>
            <h2>42</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #ff33ff",
          }}
        >
          <div className="text_container">
            <h5>Categories</h5>
            <h2>30</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #ff3385",
          }}
        >
          <div className="text_container">
            <h5>Food Items</h5>
            <h2>455</h2>
          </div>
        </div>
        <div
          className="display_box"
          style={{
            borderBottom: "4px solid #1affd1",
          }}
        >
          <div className="text_container">
            <h5>Promotions</h5>
            <h2>10</h2>
          </div>
        </div>
      </div>
      <div className="statistics">
        <div className="date_container">
          <RangePicker disabledDate={disableFutureDates} />
          <Button
            color="#3c9daa"
            style={{
              background: "#3c9daa",
              color: "#fff",
              fontWeight: "600",
            }}
          >
            Filter By Date
          </Button>
        </div>
      </div>
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{ backgroundColor: "white" }}
        onChange={onChange}
        className="tap_container"
      >
        <TabPane tab={<span style={tabStyle}>Pending</span>} key="1">
          <div className="order_container">
            <SingleOrderPendingCard />
            <SingleOrderPendingCard />
            <SingleOrderPendingCard />
          </div>
        </TabPane>
        <TabPane tab={<span style={tabStyle}>Active</span>} key="2">
          <div className="order_container">
            <SingleOrderActiveCard />
            <SingleOrderActiveCard />
          </div>
        </TabPane>
      </Tabs>

      <div style={{ paddingBottom: "4vh" }}></div>
    </>
  );
};

export default Dashboard;
